<template>
  <div class="user-list">
    <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
      <Panel name="filter" hide-arrow>
        <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
        <div class="pull-right">
          <Tooltip content="刷新结果">
            <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip :content="filterExpandText">
            <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
          </Tooltip>
        </div>
        <div slot="content">
          <div class="padding-top-20"></div>
          <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="用户ID" prop="id">
                  <Input v-model="filterModel.id" placeholder="输入用户ID" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="姓名" prop="displayName">
                  <Input v-model="filterModel.displayName" placeholder="输入姓名" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="角色" prop="roleId" style="width: 100%">
                  <Select v-model="filterModel.roleId" filterable style="width:200px">
                    <Option v-for="(tp,idx) in roles" :key="idx" :value="parseInt(tp.tid)">{{tp.name}}</Option>
                  </Select>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="用户名" prop="loginName">
                  <Input v-model="filterModel.loginName" placeholder="输入登录用户名" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="手机号" prop="mobile">
                  <Input v-model="filterModel.mobile" placeholder="输入手机号" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="账号状态" prop="enabled">
                  <RadioGroup v-model="filterModel.enabled" type="button">
                    <Radio :label="null">不限</Radio>
                    <Radio :label="1">正常</Radio>
                    <Radio :label="0">禁用</Radio>
                  </RadioGroup>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="用户类型" prop="type" style="width: 100%">
                  <Select v-model="filterModel.type" filterable style="width:200px">
                    <Option v-for="(tp,idx) in $common.getEnumSelect($common.userType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
                  </Select>
                </FormItem>
              </i-col>
              <i-col span="16">
                <FormItem style="width: 100%; text-align:right">
                  <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                  <Divider type="vertical" />
                  <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                </FormItem>
              </i-col>
            </Row>
          </Form>
        </div>
      </Panel>
    </Collapse>
    <div class="padding-top-10"></div>
    <Modal v-model="showAssignRoleModal"
      :mask="true"
      @on-cancel="showAssignRoleModal=false;currentUserId=null;assignRoleId=null"
      title="指派角色">
      <Select v-model="assignRoleId" filterable>
        <Option :value="0">无</Option>
        <Option v-for="(tp,idx) in roles" :key="idx" :value="parseInt(tp.tid)">{{tp.name}}</Option>
      </Select>
      <div slot="footer">
        <Button type="primary" @click="submitAssignRole">提交</Button>
        <Button @click="showAssignRoleModal=false;currentUserId=null;assignRoleId=null">取消</Button>
      </div>
    </Modal>
    <!-- <Alert type="success" show-icon><b>导入完成！</b>成功 1 条，失败 0 条。</Alert> -->
    <Table border ref="dataTable"
      size="small"
      stripe
      :columns="columns"
      @on-sort-change="tableSortChange"
      :data="data">
    </Table>
    <Page class="pager"
      :total="totalCount"
      :current="currentPageIndex"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      size="small"
      show-elevator
      show-total
      show-sizer />
  </div>
</template>

<script>
export default {
  name: 'user-list',
  props: {
  },
  data () {
    return {
      tableToolsPanel: '',
      columns: [
        {
          title: '姓名',
          key: 'displayName',
          resizable: true,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '用户名',
          key: 'loginName',
          resizable: true,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '手机号',
          key: 'mobile',
          resizable: true,
          width: 120,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', null, params.row.mobile || '')
          }
        },
        {
          title: '类型',
          key: 'type',
          width: 100,
          resizable: true,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', null, this.$common.userType[params.row.type.toString()])
          }
        },
        {
          title: '角色',
          key: 'roleId',
          width: 100,
          resizable: true,
          render: (h, params) => {
            let roleId = params.row.roleId
            return h('span', null, this.getRoleName(roleId))
          }
        },
        {
          title: '状态',
          key: 'enabled',
          width: 100,
          sortable: 'custom',
          render: (h, params) => {
            return h('Tooltip', {
              props: {
                transfer: true,
                content: !params.row.enabled ? '点击启用' : '点击禁用'
              }
            }, [
              h('i-switch', {
                props: {
                  value: params.row.enabled,
                  // falseColor: 'darkred',
                  size: 'large',
                  beforeChange: () => {
                    let userId = params.row.id
                    if (!params.row.enabled) {
                      return this.enableUser(userId)
                    } else {
                      return this.disableUser(userId)
                    }
                  }
                },
                on: {
                  'on-change': (status) => {
                    params.row.enabled = status
                  }
                }
              }, [
                h('span', {
                  slot: 'open'
                }, '正常'),
                h('span', {
                  slot: 'close'
                }, '禁用')
              ])
            ])
          }
        },
        {
          title: '创建时间',
          key: 'createTime',
          resizable: true,
          sortable: 'custom'
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '修改',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'warning',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-create'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: 'user-edit', params: {user: params.row}})
                    }
                  }
                }, null),
              ]),
              h('span', null, ' '),
              h('Tooltip', {
                props: {
                  content: '重置密码',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-key'
                  },
                  on: {
                    click: () => {
                      let userId = params.row.id
                      let user = params.row
                      this.resetUserPassword(userId, user)
                    }
                  }
                }, null)
              ]),
              h('span', null, ' '),
              h('Tooltip', {
                props: {
                  content: '删除',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-trash-outline'
                  },
                  on: {
                    click: () => {
                      let userId = params.row.id
                      this.deleteUser(userId)
                    }
                  }
                }, null)
              ]),
              h('span', null, ' '),
              h('Tooltip', {
                props: {
                  content: '指派角色',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-settings'
                  },
                  on: {
                    click: () => {
                      this.currentUserId = params.row.id
                      this.showAssignRoleModal = true
                    }
                  }
                }, null)
              ])
            ])
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        id: null,
        displayName: null,
        loginName: null,
        mobile: null,
        enabled: null,
        type: null,
        roleId: null,
        createDateRange: null,
        createDateStart: null,
        createDateEnd: null,
        sortBy: 'tid',
        ascending: false
      },
      departments: [],
      curDepartmentId: null,
      roles: [],
      assignRoleId: null,
      currentUserId: null,
      showAssignRoleModal: false
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
  },
  computed: {
    filterExpandText () {
      return (this.tableToolsPanel.indexOf('filter') > -1 ? '隐藏'  :'展开') + '筛选条件'
    }
  },
  mounted () {
    this.initData()
    this.initRoles()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    refresh () {
      // console.log('123')
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initRoles () {
      let res = await this.$Api.Role.listRoles({
        name: null,
        type: null,
        isReserved: null
      }, 1, -1).catch(err => {
        console.log(err)
        this.$Message.error(err.message)
      })
      this.roles = res.data
    },
    getRoleName (roleId) {
      let role = this.roles.find(o => o.tid === roleId)
      return role ? role.name : null
    },
    async submitAssignRole () {
      return new Promise((resolve, reject) => {
        this.$Modal.confirm({
          title: '确认操作',
          content: '<p>确认设置该用户角色么？</p>',
          onOk: async () => {
            this.$Spin.show()
            await this.$Api.Auth(this).assignRoleToUser(this.currentUserId, this.assignRoleId).then(() => {
              this.$Message.success('操作成功!')
              this.showAssignRoleModal = false
              this.currentUserId = null
              this.assignRoleId = null
              this.$Spin.hide()
              resolve()
            }).catch(err => {
              this.$Notice.error({
                title: '操作失败!',
                desc: err.message
              })
              this.$Spin.hide()
              reject(err)
            })
          },
          onCancel: () => {
            reject('用户取消')
          }
        })
      })
    },
    async initData () {
      this.$Spin.show()
      let res = await this.$Api.Auth(this).listUsers(this.filterModel, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.currentPageIndex = res.currentPage
      this.pageSize = res.pageSize
      this.data = res.data
      this.$Spin.hide()
    },
    async enableUser (userId) {
      return new Promise((resolve, reject) => {
        this.$Modal.confirm({
          title: '确认操作',
          content: '<p>确认启用该用户么？</p>',
          onOk: async () => {
            this.$Spin.show()
            await this.$Api.Auth(this).enableUser(userId).then(() => {
              this.$Message.success('操作成功!')
              this.$Spin.hide()
              resolve()
            }).catch(err => {
              this.$Notice.error({
                title: '操作失败!',
                desc: err.message
              })
              this.$Spin.hide()
              reject(err)
            })
          },
          onCancel: () => {
            reject('用户取消')
          }
        })
      })
    },
    async disableUser (userId) {
      return new Promise((resolve, reject) => {
        this.$Modal.confirm({
          title: '确认操作',
          content: '<p>确认禁用该用户么？</p>',
          onOk: async () => {
            this.$Spin.show()
            await this.$Api.Auth(this).disableUser(userId).then(() => {
              this.$Message.success('操作成功!')
              this.$Spin.hide()
              resolve()
            }).catch(err => {
              this.$Notice.error({
                title: '操作失败!',
                desc: err.message
              })
              this.$Spin.hide()
              reject(err)
            })
          },
          onCancel: () => {
            reject('用户取消')
          }
        })
      })
    },
    async resetUserPassword (userId, user) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认重置该用户密码么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          let newPass = await this.$Api.Auth(this).resetUserPass(userId).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          // this.$Message.success('操作成功!')
          // debugger
          setTimeout(() => {
            this.showNewPass(newPass, user)
          }, 1000)
          // this.$Spin.hide()
        },
        onCancel: () => {
        }
      })
    },
    showNewPass (newPass, user) {
      this.$Modal.success({
        title: '密码重置成功',
        content: `${user ? '账户:' + user.displayName + '(' + user.loginName + ')<br>' : ''}新密码为：<b>${newPass}</b><br>请及时保存（点击确定复制）。`,
        onOk: () => {
          require('./../../utils/common').copyToClip(newPass, '已复制到剪切板')
        }
      })
    },
    async deleteUser (userId) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该用户么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.Auth(this).deleteUser(userId).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
          this.data.splice(this.data.findIndex(o => {return o.id === userId}), 1)
          this.totalCount -= 1
        },
        onCancel: () => {
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
</style>
